module.exports = __webpack_public_path__ + "static/teleco_2-1734a2f0419068a96c5d69c8519cfe67.jpg";